'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Avatar/Avatar.js');
require('../../DataDisplays/Label/Label.js');
var ProductIcon = require('../../DataDisplays/ProductIcon/ProductIcon.js');
require('../../DataDisplays/SystemIcon/Icons/Medium/MediumBell.js');
var Button = require('../../Inputs/Button/Button.js');

/**
 * 사용자에게 정보를 표시하는 메시지 바 컴포넌트입니다.
 *
 * @component
 *
 * @param {Object} props
 * @param {'primary' | 'white'} props.variant - 메시지 바의 스타일 변형. 'primary' 또는 'white' 중 선택
 * @param {(typeof MediumProductIconNames)[number]} props.icon - 메시지 바에 표시될 ProductIcon 이름
 *        ('person_smile', 'lock', 'logout', 'contract_pen', 'paper_pen', 'paper_hold' 등)
 * @param {string} [props.title] - 메시지 바의 제목 (선택사항)
 * @param {string} props.text - 메시지 바에 표시될 본문 텍스트
 * @param {string} [props.buttonName] - 버튼에 표시될 텍스트 (선택사항)
 * @param {() => void} [props.onClick] - 버튼 클릭 시 실행될 콜백 함수 (선택사항)
 *
 * @example
 * // 기본 사용 예시
 * <MessageBar
 *   variant="primary"
 *   icon="person_smile"
 *   title="알림"
 *   text="새로운 메시지가 도착했습니다."
 *   buttonName="확인"
 *   onClick={() => console.log('버튼이 클릭되었습니다')}
 * />
 *
 * // 제목과 버튼이 없는 간단한 메시지
 * <MessageBar
 *   variant="white"
 *   icon="paper_pen"
 *   text="작업이 성공적으로 완료되었습니다."
 * />
 *
 * // 보안 관련 메시지
 * <MessageBar
 *   variant="primary"
 *   icon="lock"
 *   title="보안 알림"
 *   text="계정의 보안을 위해 비밀번호를 변경해주세요."
 *   buttonName="비밀번호 변경"
 *   onClick={() => handlePasswordChange()}
 * />
 */ const MessageBar = ({ variant = 'primary', icon, title, text, buttonName, onClick })=>{
    const isPrimary = variant === 'primary';
    const isWhite = variant === 'white';
    return jsxRuntime.jsxs(Box, {
        "data-testid": "design-system-message-bar",
        className: tailwindMerge.twMerge('flex w-full items-center gap-5 rounded-2xl border px-8 py-5', isPrimary && 'border-primary-100 bg-primary-10', isWhite && 'border-w-gray-200 bg-white'),
        children: [
            jsxRuntime.jsx(Box, {
                className: "shrink-0",
                "data-testid": "design-system-message-bar--icon",
                children: jsxRuntime.jsx(ProductIcon, {
                    name: icon,
                    size: "medium"
                })
            }),
            jsxRuntime.jsxs(Box, {
                className: "flex w-full flex-col gap-1",
                children: [
                    title && jsxRuntime.jsx(Typography, {
                        variant: "subTitle2",
                        className: "font-medium text-w-gray-900",
                        "data-testid": "design-system-message-bar--title",
                        children: title
                    }),
                    jsxRuntime.jsx(Typography, {
                        variant: "body1",
                        className: "text-w-gray-600",
                        "data-testid": "design-system-message-bar--text",
                        children: text
                    })
                ]
            }),
            buttonName && onClick && jsxRuntime.jsx(Button, {
                variant: "outlined",
                size: "sm",
                className: "shrink-0",
                onClick: onClick,
                "data-testid": "design-system-message-bar--button",
                children: buttonName
            })
        ]
    });
};

module.exports = MessageBar;
